import { render, staticRenderFns } from "./ToggleBtns.vue?vue&type=template&id=b5675396&"
import script from "./ToggleBtns.vue?vue&type=script&lang=js&"
export * from "./ToggleBtns.vue?vue&type=script&lang=js&"
import style0 from "./ToggleBtns.vue?vue&type=style&index=0&id=b5675396&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports